var _circle, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcOpned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0007,
    cy: 10.0007,
    r: 6.66667,
    fill: "#1177BD"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.0007,
    cy: 28.3327,
    rx: 11.6667,
    ry: 6.66667,
    fill: "#84DCC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcOpned);
export default __webpack_public_path__ + "static/media/ac-opned.c79ace2d58e24483fa34473762cc8e9f.svg";
export { ForwardRef as ReactComponent };